import { render, staticRenderFns } from "./voicePlayer.vue?vue&type=template&id=6bc8afe7&scoped=true&"
import script from "./voicePlayer.vue?vue&type=script&lang=js&"
export * from "./voicePlayer.vue?vue&type=script&lang=js&"
import style0 from "./voicePlayer.vue?vue&type=style&index=0&id=6bc8afe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8afe7",
  null
  
)

export default component.exports